import React from "react";
import PropTypes from "prop-types";
import Slick from "react-slick";
import cs from "classnames";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Arrow from "./components/Arrow";
import classes from "./Slider.module.scss";
import { LOCALES, useLocale } from "../../../hooks/useLocale/useLocale";

const AppendDots = (dots) => (
  <div>
    <ul className="d-flex jc-center ai-center mt-06">{dots}</ul>
  </div>
);

const CustomPaging = () => <div className={classes.dot} />;

const Slider = ({
  children,
  className,
  sliderRef,
  arrowname,
  rotated = true,
  ...properties
}) => {
  const locale = useLocale(); // Get the locale from domain
  const isRTL = locale === LOCALES.HE; // Check if Hebrew (RTL)

  const handleInitialRTLScroll = (slider) => {
    if (isRTL && slider) {
      slider.slickGoTo(children[0].length);
    }
  };

  return (
    <>
      <Slick
        ref={(c) => {
          if (sliderRef) sliderRef.set(c);
          handleInitialRTLScroll(c);
        }}
        touchThreshold={18}
        appendDots={AppendDots}
        className={cs(classes.container, className, isRTL && "rtl")}
        customPaging={CustomPaging}
        nextArrow={<Arrow arrowname={arrowname} rotated={rotated} />}
        prevArrow={<Arrow arrowname={arrowname} />}
        rtl={isRTL}
        {...properties}
      >
        {children}
      </Slick>
    </>
  );
};

Slider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  arrowname: PropTypes.string,
  rotated: PropTypes.bool,
  sliderRef: PropTypes.any,
};

Slider.defaultProps = {
  className: "",
};

export default Slider;
